import {
  REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS,
  REPORT_CARD_CONTENT_ORDER_HISTORY,
  REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS,
  REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME,
  REPORT_CARD_EXPIRING_REWARDS,
  REPORT_CARD_EXPIRING_WELLNESS,
  SEARCH_CARD_CLIENT_CONTENT,
} from '/enum/reportCard.enum';

import {Loading as ClientSearchContentLoading} from '../../ClientSearchContent';
import {Loading as ExpiringRewardsClientsContent} from '../../ExpiringRewardsReportContent';
import {Loading as ExpiringWellnessCreditsContent} from '../../ExpiringWellnessCreditsReportContent';
import {Loading as NewClientsWithoutOrdersReportContent} from '../../NewClientsWithoutOrdersReportContent';
import {Loading as OrderHistoryContent} from '../../OrderHistoryReportContent';
import {Loading as PremierCancellationsReportContent} from '../../PremierCancellationsReportContent';
import {Loading as ProjectedPremierVolumeReportContent} from '../../ProjectedPremierVolumeReportContent';

export const ALL_CONTENT = {
  [REPORT_CARD_CONTENT_ORDER_HISTORY]: OrderHistoryContent,
  [REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS]:
    NewClientsWithoutOrdersReportContent,
  [REPORT_CARD_EXPIRING_WELLNESS]: ExpiringWellnessCreditsContent,
  [SEARCH_CARD_CLIENT_CONTENT]: ClientSearchContentLoading,
  [REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME]:
    ProjectedPremierVolumeReportContent,
  [REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS]:
    PremierCancellationsReportContent,
  [REPORT_CARD_EXPIRING_REWARDS]: ExpiringRewardsClientsContent,
};
